import React, { Component } from 'react';
import img from '../../../assets/Admin/Client_Content/33630dddc9a1b52948f4e598fa7a132e_html_9a5c0b037c01a177.png';
import img1 from '../../../assets/Admin/Client_Content/33630dddc9a1b52948f4e598fa7a132e_html_a69801c1ea313e28.png';
class ClientContent extends Component {
    render() {
        return (
            <div className="mi_main">
                <p ><b > Create Carrier:</b></p>
                <p>    User can create carrier to application from Carrier menu . User enters carrier demographic details in Create carrier screen.</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img} />
                <p ><b > Add Plans and Profiles:</b></p>
                <p>User can add plans and profiles to the carrier. Carrier can have multiple plan and profiles with different LOA (Commercial, Medicare) . Plans and Profiles are added through file upload.</p>
                <img width="100%" height="100%" style={{marginBottom:"50px"}} alt="example"  src={img1} />
            </div>
        )
    }
}
export default ClientContent;
